import { render, staticRenderFns } from "./FormCrudShape.vue?vue&type=template&id=55caab3f"
import script from "./FormCrudShape.vue?vue&type=script&lang=js"
export * from "./FormCrudShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports